import React from 'react'
import TablePagination from 'components/TablePagination'
import { textLabels } from 'utils/constants/textLabels'

const generateOptions = (filename) => {
  const options = {
    filterType: 'checkbox',
    selectableRows: 'none',
    responsive: 'vertical',
    filter: true,
    search: true,
    searchPlaceholder: 'Digite o CPF ou nome da pessoa',
    searchOpen: true,
    print: false,
    download: true,
    downloadOptions: {
      filename: filename,
      filterOptions: {
        useDisplayedRowsOnly: false,
        useDisplayedColumnsOnly: false,
      },
    },
    viewColumns: true,
    pagination: true,
    rowsPerPage: 5,
    rowsPerPageOptions: [5, 10, 15, 20, 30],
    textLabels,
    customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
      return (
        <TablePagination
          count={count}
          page={page}
          rowsPerPage={rowsPerPage}
          changeRowsPerPage={changeRowsPerPage}
          changePage={changePage}
          component="div"
          options={options}
        />
      )
    },
  }
  return options
}

export default generateOptions
